import { Component, Input, Output, EventEmitter, Renderer2, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectBackendService } from 'src/app/service/connect-backend.service';
import pageSettings from '../../config/page-settings';

@Component({
  selector: 'header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnDestroy {
  @Input() pageSidebarTwo;
	@Output() toggleSidebarRightCollapsed = new EventEmitter<boolean>();
	@Output() toggleMobileSidebar = new EventEmitter<boolean>();
	@Output() toggleMobileRightSidebar = new EventEmitter<boolean>();
	pageSettings = pageSettings;

	user_name = localStorage.getItem('name')

  mobileSidebarToggle() {

		this.toggleMobileSidebar.emit(true);
  }
  mobileRightSidebarToggle() {

		this.toggleMobileRightSidebar.emit(true);
  }
	toggleSidebarRight() {

		this.toggleSidebarRightCollapsed.emit(true);
	}

	mobileTopMenuToggle() {

	  this.pageSettings.pageMobileTopMenuToggled = !this.pageSettings.pageMobileTopMenuToggled;
	}

	mobileMegaMenuToggle() {

	  this.pageSettings.pageMobileMegaMenuToggled = !this.pageSettings.pageMobileMegaMenuToggled;
	}

	ngOnDestroy() {
	  this.pageSettings.pageMobileTopMenuToggled = false;
	  this.pageSettings.pageMobileMegaMenuToggled = false;
	}

  constructor(private renderer: Renderer2, private router: Router, private client: ConnectBackendService) {

  }

  logOut(){
      this.client.get('/logout-web').subscribe((resp: any) => {
		if(resp.status === 'success')
		{
			localStorage.removeItem("JposToken");
			localStorage.clear();
			this.router.navigate(['/login'])
		}
	  })
	  
  }
}
